import { isBrand } from "../../global/environmentVariables";

import PrivacyBCP from "./privacy/PrivacyBCP";

export default function Privacy() {
  if (isBrand("catan")) {
    // return <PrivacyCatan />;
  }
  return <PrivacyBCP />;
}
